/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Ivan Ryabov, Leonid Khramov
 */
import React, { Component } from "react"
import { Input, Element } from "trux"

import "./Autocomplete.css"

export default class Autocomplete extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isActive: false,
            activeLineIx: 0,
        }

        this.focus = this.focus.bind(this)
        this.blur = this.blur.bind(this)
        this.keyDown = this.keyDown.bind(this)

        this.suggestionsEl = null
        this.activeSuggestionEl = null
    }

    renderSuggestionContent(el) {
        if (this.props.renderSuggestionContent)
            return this.props.renderSuggestionContent(el)
        return (
            <Element
                tag="a"
                href="#el"
                onClick={(e) => this.props.suggestionsPressed(e, el)}
            >
                {el.title}
            </Element>
        )
    }

    renderSuggestions() {
        if (this.props.suggestions && this.props.suggestions.length) {
            const openedClass = this.state.isActive ? "opened" : "closed"
            const items = this.props.suggestions.map((el, ix) => {
                const activeClass =
                    this.state.activeLineIx === ix ? "active" : ""
                return (
                    <li
                        key={ix}
                        className={activeClass}
                        ref={(el) => {
                            if (this.state.activeLineIx === ix)
                                this.activeSuggestionEl = el
                        }}
                        onClick={(e) => this.props.suggestionsPressed(e, el)}
                    >
                        {this.renderSuggestionContent(el)}
                    </li>
                )
            })
            return (
                <ul
                    className={`suggestions ${openedClass}`}
                    ref={(el) => (this.suggestionsEl = el)}
                >
                    {items}
                </ul>
            )
        } else {
            this.suggestionsEl = null
            this.activeSuggestionEl = null
            return null
        }
    }

    focus() {
        this.setState({
            isActive: true,
        })
    }

    blur() {
        setTimeout(() => {
            this.setState({
                isActive: false,
            })
        }, 200)
        if (this.props.onBlur) {
            this.props.onBlur()
        }
    }

    keyDown(e) {
        if (this.props.suggestions && this.props.suggestions.length) {
            let activeLineIx = this.state.activeLineIx
            switch (e.key) {
                case "ArrowDown":
                    ++activeLineIx
                    if (activeLineIx >= this.props.suggestions.length) {
                        activeLineIx = this.props.suggestions.length - 1
                    }
                    this.setState({
                        activeLineIx,
                    })
                    if (this.suggestionsEl && this.activeSuggestionEl) {
                        this.suggestionsEl.scrollTo(
                            0,
                            this.activeSuggestionEl.offsetTop
                        )
                    }
                    break
                case "ArrowUp":
                    --activeLineIx
                    if (activeLineIx < 0) {
                        activeLineIx = 0
                    }
                    this.setState({
                        activeLineIx,
                    })
                    if (this.suggestionsEl && this.activeSuggestionEl) {
                        this.suggestionsEl.scrollTo(
                            0,
                            this.activeSuggestionEl.offsetTop - 50
                        )
                    }
                    break
                case "Enter":
                    if (this.suggestionsEl && this.activeSuggestionEl) {
                        this.activeSuggestionEl.firstElementChild.click()
                    }
                    break
                default:
                    break
            }
        }
    }

    render() {
        const openedClass = this.state.isActive ? "opened" : "closed"

        return (
            <Element className={"Autocomplete"}>
                <Input
                    type={Input.Type.Text}
                    label="Full name"
                    value={this.props.value}
                    onChange={this.props.onChange}
                    name={this.props.name}
                    onFocus={this.focus}
                    onBlur={this.blur}
                    width={"100%"}
                    error={this.props.error}
                    onKeyDown={this.keyDown}
                />
                {this.renderSuggestions()}
                <Element className={`backdrop ${openedClass}`}></Element>
            </Element>
        )
    }
}
